'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { PlayerGear } from '@/modules/players/v3/types';
import { addGearToFavorites } from '@/utils/actions/players/edit/gear/addGearToFavorites';
import { removeGearFromFavorites } from '@/utils/actions/players/edit/gear/removeGearFromFavorites';

export const useGearFavorites = (playerUuid: string, queryKey: string) => {
  const queryClient = useQueryClient();

  const setFavorite = (playerGearId: string, isFavorite: boolean) => {
    queryClient.setQueryData<PlayerGear[]>([queryKey, playerUuid], (old) =>
      old?.map((gear) => (gear.uuid === playerGearId ? { ...gear, isFavorite } : gear))
    );
  };

  const removeFromFavorites = useMutation({
    mutationFn: (playerGearId: string) => removeGearFromFavorites({ playerUuid, playerGearId }),
    onSuccess: (_data, playerGearId) => {
      setFavorite(playerGearId, false);
      toast.success('Success');
    },
    onError: () => toast.error('Error while updating favorites'),
  });

  const addToFavorites = useMutation({
    mutationFn: (playerGearId: string) => addGearToFavorites({ playerUuid, playerGearId }),
    onSuccess: (_data, playerGearId) => {
      setFavorite(playerGearId, true);
      toast.success('Success');
    },
    onError: () => toast.error('Error while updating favorites'),
  });

  return {
    addToFavorites,
    removeFromFavorites,
  };
};
